import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Layouts & Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import AboutPage from "./pages/AboutPage";
import AuthDispatcher from "./components/auth/AuthDispatcher";
import CalculatorLayout from "./layouts/CalculatorLayout";
import CampusLayout from "./components/campus/CampusLayout";

// Auth Handler Component
const AuthRedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check URL for Magic Link / OAuth tokens
    const hashParams = new URLSearchParams(location.hash.substring(1));
    const queryParams = new URLSearchParams(window.location.search);

    // Only redirect if we are processing a login link
    // AND we are not already on the campus page (to avoid loops/redundant renders)
    if (
      (hashParams.has("access_token") ||
        queryParams.has("code") ||
        hashParams.has("type") ||
        queryParams.has("error")) &&
      location.pathname !== "/campus"
    ) {
      // Pass the hash and search params to /campus so Supabase can read them there
      navigate({
        pathname: "/campus",
        hash: location.hash,
        search: location.search,
      }, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

// Wrapper for CampusLayout to provide navigation prop
const CampusLayoutWrapper = () => {
  const navigate = useNavigate();
  return <CampusLayout onExit={() => navigate("/")} />;
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-slate-50">
        <AuthRedirectHandler />
        <ToastContainer position="bottom-right" />

        <Routes>
          {/* Smart Entry Point */}
          <Route path="/" element={<AuthDispatcher />} />

          {/* Authentication */}
          <Route path="/login" element={<LoginPage />} />

          {/* Marketing/About Page */}
          <Route path="/welcome" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />

          {/* Main App (Campus) */}
          <Route path="/campus" element={<CampusLayoutWrapper />} />

          {/* Utilities (Calculator) */}
          <Route path="/calculator" element={<CalculatorLayout />} />
        </Routes>

        <Analytics />
      </div>
    </Router>
  );
}

export default App;
